import React from 'react';
import { ModalContent } from 'fronton-react';
import {
  ButtonWithGAClickButton,
  List,
  ListItem,
  ModalContentAction,
  ModalHeader,
  Typography,
} from 'common/components';
import {
  guaranteeGoods,
  guaranteeModalList,
  guaranteeModalSubtitle,
  guaranteeGoodsTerms,
} from './guarantee-modal-styles';
import { KITCHEN_ELEMENT_BLOCK, GUARANTEE_DOC } from '../../../../../kitchen-constants';

export const GuaranteeModal = () => (
  <>
    <ModalHeader title="Гарантия 25 лет" />
    <ModalContent>
      <Typography className={guaranteeGoods} variant="m" size="body_long">
        Мы&nbsp;даём гарантию 25&nbsp;лет на&nbsp;товары:
      </Typography>
      <List className={guaranteeModalList} listStyle="disc">
        <ListItem>
          <Typography variant="m" size="body_long">
            каркасы кухонных шкафов
          </Typography>
        </ListItem>
        <ListItem>
          <Typography variant="m" size="body_long">
            фасады
          </Typography>
        </ListItem>
        <ListItem>
          <Typography variant="m" size="body_long">
            петли для навески фасадов с&nbsp;доводчиком и&nbsp;без него
          </Typography>
        </ListItem>
        <ListItem>
          <Typography variant="m" size="body_long">
            металлические выдвижные ящики
          </Typography>
        </ListItem>
      </List>

      <ModalHeader className={guaranteeModalSubtitle} title="Возврат" />
      <Typography className={guaranteeGoods} variant="m" size="body_long">
        Вы можете вернуть товар:
      </Typography>
      <List listStyle="disc">
        <ListItem>
          <Typography as="span" variant="m" size="body_long">
            В&nbsp;течение 100 дней с&nbsp;даты покупки. Для возврата товара нужен чек, номер заказа или
            другой документ, подтверждающий оплату.
          </Typography>
        </ListItem>
        <ListItem>
          <Typography as="span" variant="m" size="body_long">
            В&nbsp;течение 365 дней с&nbsp;даты покупки при наличии Сервисной карты, которую
            вы&nbsp;предъявляли при покупке. Чек не&nbsp;нужен.
          </Typography>
        </ListItem>
      </List>
      <Typography className={guaranteeGoodsTerms} variant="m" size="body_long">
        Мы&nbsp;принимаем к&nbsp;возврату товары, которые не&nbsp;использовались, сохранили товарный вид
        и&nbsp;потребительские свойства, со&nbsp;всеми заводскими пломбами и&nbsp;ярлыками.
      </Typography>
      <ModalContentAction>
        <ButtonWithGAClickButton
          adaptive={false}
          elementBlock={KITCHEN_ELEMENT_BLOCK}
          elementName="Гарантия 25 лет / modal"
          elementText="Смотреть полные условия"
          variant="outline"
          wide
          href={GUARANTEE_DOC}
          target="_blank">
          Смотреть полные условия
        </ButtonWithGAClickButton>
      </ModalContentAction>
    </ModalContent>
  </>
);
